// /utils/measureLoadTime.js

export function measureLoadTime(callback) {
  //console.log('measureLoadTime called');

  const checkNavigationEntries = () => {
    const [navigation] = performance.getEntriesByType('navigation');
    //console.log('navigation entry:', navigation);

    if (navigation) {
      const pageLoadTime = Math.round(navigation.loadEventEnd - navigation.startTime);
      //console.log('Page load time measured:', pageLoadTime);

      if (pageLoadTime >= 0) {
        callback(pageLoadTime);
      } else {
        //console.log('Invalid load time:', pageLoadTime);
      }
    } else {
      //console.log('No navigation entries found yet, checking again...');
      if (attempts < maxAttempts) {
        attempts += 1;
        setTimeout(checkNavigationEntries, checkInterval);
      } else {
        //console.log('Max attempts reached, unable to measure load time accurately');
      }
    }
  };

  const maxAttempts = 10;
  const checkInterval = 500;
  let attempts = 0;

  // Start the initial check
  setTimeout(checkNavigationEntries, checkInterval);
}
